<template>
    <div class="powerpage-tab">
        <a @click.prevent="savePowerpage" class="btn btn--orange store-powerpage" href="#">
            {{ $t('categories.store_powerpage') }}
        </a>

        <div class="field field--push-medium field--checkbox" style="margin-top: 48px">
            <input type="checkbox" id="isVisible" v-model="category.powerpage_enabled" @change="savePowerpageStatus" />
            <div class="field-control">
                <label for="isVisible">Powerpage inschakelen</label>
            </div>
        </div>

        <PowerpageCreateForm :is-category="true"
                             :is-relationship="true"
                             :page-id="category.powerpages_page_id ? category.powerpages_page_id : null"
                             ref="powerpageForm"
                             @powerpageSaved="setPowerpage" />
    </div>
</template>

<script>
    import { CategoryService } from '../../../services';
    import PowerpageCreateForm from '../../powerpages/PowerpageCreateForm';

    export default {
        components: { PowerpageCreateForm },
        props: {
            category: {
                required: true,
            },
        },
        methods: {
            storeSeo() {
                this.$store.commit('categories/set_category', this.category);
            },
            async savePowerpageStatus() {
                return CategoryService.updatePowerpageEnabled(this.category.id, this.category.powerpage_enabled)
                                     .then(() => {
                                         this.$flashMessage(this.category.powerpage_enabled ? this.$t('products.powerpage_enabled') : this.$t('products.powerpage_disabled'), 3500, 'success');
                                     })
                                     .catch((err) => {
                                         const firstError = err.response.data.errors[Object.keys(err.response.data.errors)[0]];
                                         this.$flashMessage(firstError[0], 3500, 'error');
                                     });
            },
            async savePowerpage() {
                await this.$refs.powerpageForm.savePowerpage(true);
            },
            async setPowerpage($id) {
                this.category.powerpages_page_id = $id;
                await this.$store.commit('categories/set_category', this.category);

                let promise = this.$store.dispatch('categories/update_category');

                promise.then(() => {
                    this.$flashMessage(this.$t('products.update_success'), 3500, 'success');
                });

                promise.catch(err => {
                    const errors = Object.entries(err.response.data.errors)
                                         .map((err) => err[1])
                                         .flat()
                                         .join('<br />');

                    this.$flashMessage(errors, 3500, 'error');
                });
            },
        },
        name: 'PowerpageTab',
    };
</script>
<style lang="scss" scoped>
    .powerpage-tab {
        .store-powerpage {
            margin-bottom : 30px;
            float         : right;
        }
    }
</style>
